import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CountryCityService } from '../country-city.service';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-add-city',
  templateUrl: './add-city.component.html',
  styleUrls: ['./add-city.component.scss']
})
export class AddCityComponent implements OnInit {
  uploadForm: FormGroup;

  model: any = {};
  show = false;
Imagefile: string;
  id: number;
  constructor(
    private formBuilder: FormBuilder,

    private countryService: CountryCityService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.id = this.route.snapshot.params['id'];
    // console.log(this.id);
   }

  ngOnInit() {
    this.uploadForm = this.formBuilder.group({
      file: ['']
    });
  }
  onSubmit() {
    this.model.CountryId =  this.id;
    this.countryService.addCity(this.model).subscribe((Data: any) => {
      this.toastr.success('City added');
      if (!Data.id) {
        this.router.navigateByUrl('/country/city-list/' + this.id);
      }

    });
  }


}
